import React from 'react'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { Delete, Edit } from '@mui/icons-material'
import { t } from 'i18next'

type ChoicePopupProps = {
  isOpen: boolean
  onClose: () => void
  openEdit: () => void
  closeView: () => void
  anchor: HTMLElement | null
  setIsOpenConfirm: React.Dispatch<React.SetStateAction<boolean>>
}

const ChoicePopup: React.FC<ChoicePopupProps> = ({
  isOpen,
  onClose,
  anchor,
  openEdit,
  closeView,
  setIsOpenConfirm,
}) => {
  return (
      <Menu
        className={isOpen ? 'vacation-dialog-open' : ''}
        anchorEl={anchor}
        open={isOpen}
        onClose={onClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      >
        <MenuItem
          onClick={() => {
            onClose()
            closeView()
            openEdit()
          }}
          sx={{ color: 'text.highEmphasis', svg: { color: 'text.highEmphasis' } }}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText>{t('page.projects.actionPopup.edit')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={async () => {
            closeView()
            setIsOpenConfirm(true)
            onClose()
          }}
          sx={{ color: 'text.highEmphasis', svg: { color: 'text.highEmphasis' } }}
        >
          <ListItemIcon>
            <Delete />
          </ListItemIcon>
          <ListItemText>{t('page.projects.actionPopup.delete')}</ListItemText>
        </MenuItem>
      </Menu>
  )
}

export default ChoicePopup
